import type { SVGProps } from 'react';

const SvgArrowRightDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={20}
    viewBox='0 0 20 20'
    width={20}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M4.442 4.558a.625.625 0 1 0-.884.884L8.116 10l-4.558 4.558a.625.625 0 1 0 .884.884l5-5a.625.625 0 0 0 0-.884zm7 0a.625.625 0 1 0-.884.884L15.116 10l-4.558 4.558a.625.625 0 1 0 .884.884l5-5a.625.625 0 0 0 0-.884z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgArrowRightDouble;
